var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"world-map"},[_c('div',{ref:"mapContainer",staticStyle:{"height":"100%","width":"100%"}}),_c('div',{staticClass:"world-map__overlay"},[_vm._v("Say \"hello from_____\" to get on the map!")])])}
var staticRenderFns = []

export { render, staticRenderFns }